// 产品类型分类器
class ProductTypeClassifier {
  constructor() {
    this.productTypes = {
      // 粉末/颗粒状产品
      // 粉末/颗粒状产品
      'TY-P': ['水提工艺', '发酵工艺', 'CO2/Water工艺'],
      'HEXT': ['Water Extraction', 'Fermentation', 'CO2/Water Extraction'],
      'F&V': ['Water Extraction', 'Fermentation', 'CO2/Water Extraction'],
      'PCG': ['Water Extraction', 'Fermentation', 'CO2/Water Extraction'],
      'REXT': ['Water Extraction', 'Fermentation', 'CO2/Water Extraction'],
      'PCG-CSFMU-S': ['Water Extraction', 'Fermentation', 'CO2/Water Extraction'],
      'PCG-CSFMU-B': ['Water Extraction', 'Fermentation', 'CO2/Water Extraction'],
      'SDNP': ['Water Extraction', 'Fermentation', 'CO2/Water Extraction'],
      'OEXT': ['Water Extraction', 'Fermentation', 'CO2/Water Extraction'],
      'CSFMU-S': ['Water Extraction', 'Fermentation', 'CO2/Water Extraction'],
      'CSFMU-B': ['Water Extraction', 'Fermentation', 'CO2/Water Extraction'],
      
      // 液体产品
      'TY-L': ['多元醇提取液', '发酵液', '普通提取液'],
      'Liquid EXT-S': ['Polyol Extracted Liquid', 'Fermentated Liquid Extract', 'Regular Liquid Extract'],
      'Liquid EXT-B': ['Polyol Extracted Liquid', 'Fermentated Liquid Extract', 'Regular Liquid Extract'],
      
      // 特殊工艺产品
      'TY-EHXTO': '超临界流体萃取工艺',
      'TY-SHXTO': '超临界流体萃取工艺',
      'EHXTO': 'Supercritical Fluid Extraction',
      'SHXTO': 'Supercritical Fluid Extraction'
    };
    
    this.productDescriptions = {
      // 中文描述
      '水提工艺': '本产品是由Draco特有的控温全谱水提工艺提取、喷雾干燥制成的粉末状/颗粒状天然植物提取物。除纯水外，生产过程中未使用其它溶剂。该产品为天然植物来源，富含多种生物活性成分，具有良好的水溶性。该有机认证的生产工艺已通过全球食品安全倡议(GFSI)和SQF III及欧盟化妆品原料GMP体系的审核和认证，符合国际安全与质量标准。',
      
      '发酵工艺': '本产品是由Draco特有的全谱生物发酵工艺制成的粉末状/颗粒状天然植物提取物。发酵工艺有助于分解植物纤维细胞壁，释放生物活性物质，使产品具有更好的溶解性和更高的吸收率。该有机认证的生产工艺已通过全球食品安全倡议(GFSI)和SQF III及欧盟化妆品原料GMP体系的审核和认证，符合国际安全与质量标准。',
      
      'CO2/Water工艺': '本产品是采用CO2超临界流体萃取与水提取相结合的工艺制成的粉末状/颗粒状天然植物提取物。在超临界条件下，CO2具有优异的溶解力与渗透性，可高效提取植物中非极性、脂溶性活性成分；同时，通过纯水提取工艺可充分溶出极性和水溶性成分。该复合提取工艺结合了两种溶剂体系的优势，实现了植物活性物质的全谱提取(FullSpectrum Extraction)，最大限度保留植物中的生物活性成分。整个过程在控温，无溶剂残留的条件下进行，确保产品的高纯度、安全性与功能性。该有机认证的生产工艺已通过全球食品安全倡议(GFSI)和SQF III及欧盟化妆品原料GMP体系的审核和认证，符合国际安全与质量标准。',
      
      '多元醇提取液': '本产品是由Draco特有的控温全谱工艺制成的天然植物提取物和特定溶剂复配制成。全谱提取的生产工艺已通过全球食品安全倡议(GFSI)和SQFIII及欧盟化妆品原料GMP体系的审核和认证，符合国际安全与质量标准。复配的方式在确保提取效率的同时，最大程度保留植物活性成分的天然特性与稳定性，更易于应用于各类配方中。',
      
      '发酵液': '本产品是由本公司特有的全谱生物发酵制成的天然植物提取液。发酵工艺有助于分解植物纤维细胞壁，并释放活性物质。发酵过程中产生的生物活性化合物具有更好的水溶性和更高的吸收率。该有机认证的生产工艺已通过全球食品安全倡议(GFSI)和SQF III及欧盟化妆品原料GMP体系的审核和认证，符合国际安全与质量标准。',
      
      '普通提取液': '本产品是由Draco特有的控温全谱工艺提取制成的天然植物提取液。该产品为天然来源，富含多种植物生物活性成分，具有良好的溶解性，能够充分发挥植物的天然功效。该有机认证的生产工艺已通过全球食品安全倡议(GFSI)和SQF III及欧盟化妆品原料GMP体系的审核和认证，符合国际安全与质量标准。',
      
      '超临界流体萃取工艺': '本产品采用天然植物，经美国和欧盟有机认证的超临界流体萃取、精炼以及自主专利的低温灭菌技术等综合工艺精制而成。超临界流体具有优异的溶解力和渗透性，能够高效提取植物中的有效活性成分。整个生产过程在接近常温的条件下进行，避免了对热敏性成分的破坏，最大程度地保留了植物的生物活性，确保产品的高品质和功能性。该有机认证的生产工艺已通过全球食品安全倡议(GFSI)和SQF III及欧盟化妆品原料GMP体系的审核和认证，符合国际安全与质量标准。',
      
      // 英文描述
      'Water Extraction': 'This product is a powdered/granulated botanical extract produced through a proprietary,controlled-temperature,full-spectrum extraction process. No other solvent is used during processing except pure, clean water. It is a natural product, rich in full-spectrum phytochemicals, and offers optimal water solubility. The organic-certified manufacturing process has been audited and certified under the Global Food Safety Initiative(GFSI),SQF Level III,and EU Cosmetic Ingredient GMP systems,in full compliance with international safety and quality standards.',
      
      'Fermentation': 'The product is a powdered/granulated botanical extract prepared through full-spectrum bioactive fermentation. This fermentation process helps break down tough, fibrous plant cell wall components. New bioactive compounds are released during fermentation, exhibiting improved water solubility and enhanced absorption. The organic-certified manufacturing process has been audited and certified under the Global Food Safety Initiative(GFSI),SQF Level III,and EU Cosmetic Ingredient GMP systems,in full compliance with international safety and quality standards.',
      
      'CO2/Water Extraction': 'This product a powdered/granulated botanical extract, which is manufactured using a combined supercritical CO2 extraction and water extraction process. Under supercritical conditions, CO2 exhibits excellent solvency and permeability,efficiently extracting non-polar,lipid-soluble active compounds from plants. At the same time, pure water extraction enables the dissolution of polar, water-soluble constituents.This integrated extraction technology combines the advantages of both solvent systems to achieve a full-spectrum extraction, maximizing the retention of the plant\'s natural bioactive compounds. The entire process is carried out under controlled-temperature and solvent-free conditions,ensuring high purity, safety, and functional integrity of the final product.The organic-certified manufacturing process has been audited and certified under the Global Food Safety Initiative(GFSI),SQF Level III,and EU Cosmetic Ingredient GMP systems, in full compliance with international safety and quality standards.',
      
      'Polyol Extracted Liquid': 'The product is a liquid extract prepared by mixing a full-spectrum bioactive extract with a designated solvent. The original extract is derived from a proprietary,closed-system,controlled-temperature extraction process. The natural activity and stability of the plant extract. The organic-certified extraction process has been audited and certified under the Global Food Safety Initiative(GFSI),SQF Level III,and EU Cosmetic Ingredient GMP systems, in full compliance with international safety and quality standards. The product is rich in full-spectrum phytochemicals and can be easily incorporated into formulations.',
      
      'Fermentated Liquid Extract': 'This product is a natural liquid botanical extract prepared through our proprietary full-spectrum bioactive fermentation process. The fermentation helps break down plant cell walls and release bioactive compounds. The bioactive compounds generated during fermentation exhibit improved water solubility and enhanced absorption. The organic-certified manufacturing process has been audited and certified under the Global Food Safety Initiative(GFSI),SQF Level III,and EU Cosmetic Ingredient GMP systems, in full compliance with international safety and quality standards.',
      
      'Regular Liquid Extract': 'This product is a natural botanical liquid extract prepared using our proprietary full-spectrum extraction, controlled-temperature process. It is naturally sourced and rich in full-spectrum phytochemicals and easily integrates into formulations, helping to maximize the natural benefits of the plant. The organic-certified manufacturing process has been audited and certified under the Global Food Safety Initiative(GFSI), SQF Level III,and EU Cosmetic Ingredient GMP systems, in full compliance with international safety and quality standards.',
      
      'Supercritical Fluid Extraction': 'This product is made from natural plants and refined through supercritical fluid extraction, purification and patented controlled-temperature sterilization technology. The supercritical CO2 fluid offers exceptional solvency and permeability,allowing for the efficient extraction of key bioactive compounds from the plant matrix. The entire production process is conducted under near-ambient temperature conditions, preventing degradation of heat-sensitive components and preserving the full spectrum of natural bioactivity. This ensures superior product quality,stability,and functionality.The organic-certified manufacturing process has been audited and certified under the Global Food Safety Initiative(GFSI),SQF Level III,and EU Cosmetic Ingredient GMP systems, in full compliance with international safety and quality standards.'
    };
  }
  
  // 获取所有产品代码
  getProductCategories() {
    return Object.keys(this.productTypes);
  }
  
  // 根据产品代码获取可用的工艺类型
  getProcessTypes(productCode) {
    const result = this.productTypes[productCode];
    if (!result) {
      return [];
    }
    // 确保返回的是数组
    return Array.isArray(result) ? result : [result];
  }
  
  // 获取产品描述
  getProductDescription(processType) {
    return this.productDescriptions[processType] || '描述未找到';
  }
  
  // 获取特定产品的所有信息
  getProductInfo(productCode, processIndex = 0) {
    const processTypes = this.getProcessTypes(productCode);
    
    if (!processTypes) {
      return { error: `未找到产品代码: ${productCode}` };
    }
    
    if (processIndex >= processTypes.length) {
      return { error: `工艺索引超出范围: ${processIndex}` };
    }
    
    const processType = processTypes[processIndex];
    const category = this.getProductCategory(productCode);
    
    return {
      productCode,
      category,
      processType,
      description: this.getProductDescription(processType),
      availableProcesses: processTypes
    };
  }
  
  // 获取产品所属分类（现在直接返回产品代码）
  getProductCategory(productCode) {
    return this.productTypes[productCode] ? productCode : 'unknown';
  }
  
  // 获取所有产品代码
  getAllProductCodes() {
    return Object.keys(this.productTypes);
  }
  
  // 搜索包含特定关键词的产品描述
  searchDescriptions(keyword) {
    const results = [];
    
    for (const [processType, description] of Object.entries(this.productDescriptions)) {
      if (description.toLowerCase().includes(keyword.toLowerCase())) {
        // 找到对应的产品代码
        for (const [productCode, processes] of Object.entries(this.productTypes)) {
          if (Array.isArray(processes) && processes.includes(processType)) {
            results.push({
              productCode,
              category: productCode,
              processType,
              description: description.substring(0, 100) + '...' // 截取前100字符
            });
          } else if (processes === processType) {
            results.push({
              productCode,
              category: productCode,
              processType,
              description: description.substring(0, 100) + '...' // 截取前100字符
            });
          }
        }
      }
    }
    
    return results;
  }
}

// 导出 ProductTypeClassifier 类
export const ProductDescriptionUtils = new ProductTypeClassifier();